const dateFormater = (data) => {
  if (!data) {
    return '';
  }
  const date = new Date(data);
  return date.toLocaleDateString('uk', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const barcodeFormater = (rowData) => {
  const { products = [] } = rowData;
  const result = products.map(({ barcode }) => barcode).join(', ');
  return result;
};

const productFormater = (rowData) => {
  const { products = [], capacity } = rowData;
  const result = products.map(({ product }) => product.title).join(', ');
  return `${capacity}м³ / ${result}`;
};
const productFormaterExport = (rowData) => {
  const { products = [] } = rowData;
  const result = products.map(({ product }) => product.title).join(', ');
  return `${result}`;
};

const lengthFormater = (rowData) => {
  const { products = [] } = rowData;
  const result = products.map(({ length }) => `${length}м.`).join(', ');
  return result;
};

export const formatedItems = (arrItems, role) => {
  const result = arrItems.map((item) => {
    const ifInventory = item?.products?.some((product) => product?.date_inventory);
    return {
      _id: item?._id ?? '',
      ...(['admin']?.includes(role) ? { company_name: item?.company_name ?? '' } : {}),
      document_no: item?.document_no ?? '',
      date_posting: dateFormater(item?.created_at),
      barcode: barcodeFormater(item),
      products: productFormater(item),
      capacity: item?.capacity ?? '',
      storage: item?.storage?.title ?? '',
      supplier: item?.supplier?.title ?? '',
      carrier: item?.carrier?.title ?? '',
      length: lengthFormater(item),
      date_inventory: dateFormater(item?.date_inventory),
      comment: item?.comment ?? '',
      ifInventory,
      ...(['admin']?.includes(role) ? { user: item?.user?.title ?? '' } : {}),
    };
  });
  return result;
};

export const formatedItemsExport = (arrItems, role) => {
  const result = arrItems.map((item) => {
    return {
      ...(['admin']?.includes(role) ? { 'Підриємство ': item?.company_name ?? '' } : {}), //company_name
      'Документ №': item?.document_no ?? '', //document_no
      'Дата оприбуткування': dateFormater(item?.created_at), //date_posting
      'Бирки №': barcodeFormater(item), //barcode
      'Продукція ': productFormaterExport(item), //products
      'Об`єм в м³': item?.capacity ?? '', //capacity
      'Склад ': item?.storage?.title ?? '', //storage
      'Постачальники ': item?.supplier?.title ?? '', //supplier
      'Перевізник ': item?.carrier?.title ?? '', //carrier
      'Довжина ': lengthFormater(item), //length
      'Дата інвентарізації': dateFormater(item?.date_inventory), //date_inventory
      'Коментар ': item?.comment ?? '', //comment
      ...(['admin']?.includes(role) ? { 'Користувач ': item?.user?.title ?? '' } : {}), //user
    };
  });
  return result;
};
